<template>
  <div class="container riders">
    <v-row>
      <v-col md="12" cols="12" v-if="!loadingPage">
          <WarningAlert>
              <p v-if="age18" class="mb-0">{{ $t("riders.content_1") }}</p>
              <p v-if="age18" class="mb-0">{{ $t("riders.content_2") }}</p>
              <p v-if="age18" class="mb-0">{{ $t("riders.content_3") }}</p>

              <p v-if="!age18" class="mb-0">{{ $t("riders.content_4") }}</p>  
              <p v-if="!age18" class="mb-0">{{ $t("riders.content_5") }}</p> 
          </WarningAlert>            
      </v-col>
      <v-col v-if="age18" md="12" cols="12" class="text-right pt-0 pb-0" >
        <v-btn :color="`${buttonColor}`" dark class="mb-2" @click="addPart">
          {{ $t("riders.addRider")}}
        </v-btn>
      </v-col>
      <v-col v-if="age18" md="12" cols="12" class="pt-0">
        <v-data-table
          :headers="ridersHeaders"
          :items="ridersItems"
          class="elevation-1"
          dense
          :loading="loadingData"
          :loading-text="$t('yourRegistration.loading_text')"
          :footer-props="{
            'items-per-page-text': $t('dataTable.rowsPerPageText'),
            'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
          }"
          :no-data-text="$t('dataTable.noDataText')"
          :headerProps="{
            'sort-by-text': $t('dataTable.sortByText')
          }"
        >
          <template v-slot:top>          
            <v-dialog v-model="dialog" max-width="600px">
              <v-card>
                <v-form ref="form" @submit.prevent="editRider">
                  <v-card-title>
                    <span class="headline">{{ $t("riders.edit_rider") }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-row no-gutters class="mt-2">
                      <v-col md="6" cols="12" class="pb-0">
                        <v-text-field
                          v-model="form.fName"
                          :label="$t('riders.first_name')"
                          disabled
                          outlined dense
                        ></v-text-field>
                      </v-col>
                      <v-col md="6" cols="12" class="pb-0 pt-0">
                        <v-text-field
                          v-model="form.lName"
                          :label="$t('riders.last_name')"
                          disabled outlined dense
                        ></v-text-field>
                      </v-col>
                      <v-col md="12" cols="12" class="pb-0 pt-0">
                        <v-select 
                          outlined dense
                          v-model="form.relationship"
                          :label="$t('riders.relationship')"
                          :items="itemsRelationshipOptions"
                          :no-data-text="$t('common.no_data')"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                      @click="close"
                      :color="`${buttonColor}`"
                      class="btn mb-2"
                      >{{ $t("riders.cancel") }}</v-btn>
                    <v-btn
                      type="submit"
                      :color="`${buttonColor}`"
                      class="btn mb-2"
                    >{{ $t("riders.save") }}</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="600px">
              <v-card>
                <v-card-title class="headline">{{ $t('riders.delete_rider') }}</v-card-title>
                <v-card-text>
                  <p class="mt16">{{ $t('riders.sure_delete') }}</p>
                </v-card-text>
                <v-card-actions>
                  <v-btn class="btn mb-2 mr-2" :color="`${buttonColor}`" @click="closeDelete">{{ $t('riders.cancel') }}</v-btn>
                  <v-btn
                        :color="`${buttonColor}`"
                        class="btn mb-2"
                        @click="deleteItemConfirm"
                      >{{ $t('riders.delete') }}</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <template v-slot:[`item.relationship`]="{ item }">
              {{ $te("relationship."+(item.relationship || '').toLowerCase()) ? $t("relationship."+(item.relationship || '').toLowerCase()) : item.relationship }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon v-if="item.isEdit" small class="mr-2" @click="editItem(item)">fa far fa-pencil-alt</v-icon>
            <v-icon v-if="item.isEdit" small @click="deleteItem(item)">fa far fa-trash-alt</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <Snack :snack="snackbar" :snackMsg="msg_snackbar" :snackCol="color_snackbar"/>
  </div>
</template>

<script>
import Snack from "@/components/notifications/Snack";
import RelationshipService from "@/services/RelationshipService";
import AuthService from "@/services/AuthService";
import { VRow, VCol, VDataTable, VDialog, VCard, VSpacer, VIcon, VBtn,
         VCardTitle, VCardText, VCardActions, VForm, VTextField,
         VSelect
       } from 'vuetify/lib';
import LocalStorageService from "@/services/LocalStorageService";
import { mapState } from 'vuex';
import WarningAlert from "@/components/alert/WarningAlert";

export default {
  name: "Riders",
  components: {
    Snack,
    VRow, VCol, VDataTable, VDialog, VCard, VSpacer, 
    VCardTitle, VCardText, VCardActions, VIcon, VBtn,
    VForm, VTextField, VSelect, WarningAlert
  },
  data() {
    const ridersForm = Object.freeze({
      firstName: "",
      lastName: "",
      relationShip: ""
    });
    return {
      msg_snackbar: '',
      color_snackbar: '',
      snackbar: false,
      buttonColor: "#000",
      dialog: false,
      editedIndex: -1,
      dialogDelete: false,
      ridersForm,
      form: Object.assign({}, ridersForm),
      itemsRelationship: [],      
      ridersItems: [],
      defaultItem: {
        firstName: "",
        lastName: "",
        relationShip: ""
      },
      userRoleId: 0,
      borderAlertColor: "",
      bgAlertColor: "",
      iconAlertColor: "",
      loadingData: true
    };
  },
  created(){
    this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    this.$store.dispatch('setUserAction',{ forceUpdate: false, forceParticipants: false, disabledLoading: true });
    this.showLinkedMembers();
    this.itemsRelationship_();
  },
  mounted() {
    this.$emit("titlePage", "riders.title");
    this.$emit("dynamicMenuItems", this.dynamicMenuItems);
  },
  updated() {},
  computed: {
    ridersHeaders(){
      return [
        {
          text: this.$t("authorization.livelaps_id"),
          align: "",
          sortable: true,
          value: "userId"
        },
        {
          text: this.$t("riders.first_name"),
          align: "",
          sortable: false,
          value: "fName"
        },
        { text: this.$t("riders.last_name"), value: "lName" },
        { text: this.$t("riders.email"), value: "email" },
        { text: this.$t("riders.relationship"), value: "relationship" },
        {
          text: this.$t("riders.actions"),
          value: "actions",
          sortable: false
        }
      ]
    },
    ...mapState({
      loadingPage: (state) => {
        if(state && state.session) return state.session.loadingPage;
        return true;
      },
      age18: (state) => state.session.age18
    }),
    itemsRelationshipOptions(){
      return this.itemsRelationship.map((el) => {
        return {
          text: this.$t(`relationship.${el.toLowerCase()}`),
          value: el
        }
      }).sort((a, b) => a.text.localeCompare(b.text));
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    }
  },
  methods: {
    addPart(){
      LocalStorageService.setItem("link_back_part", this.$route.name);
      this.$router.push({
        path: "ridersCreate"
      }); 
    },
    itemsRelationship_(){
      RelationshipService.showRelationshipValues().then(response => {
        
        if(response.data.success == 1){
          this.itemsRelationship = response.data.message;
        }
      });
    },
    async showLinkedMembers(){
      let riders = [];
      await AuthService.getUserCurrent().then(response =>{
        if(response.data.success == 1){
          this.ridersItems.push({
            userId: response.data.message.id,
            linkedMemberId: response.data.message.id,
            fName: response.data.message.firstName,
            lName: response.data.message.lastName,
            relationship: "you",
            isEdit: false,
            birthday: response.data.message.birthday,
            email: response.data.message.email
          });
        }
      });
      await RelationshipService.getUserRoles().then(response =>{
        let userRolesItems = [];
        if(response.data.success == 1){
          userRolesItems = response.data.message;
          userRolesItems.find(x => {
            if(x.userRoleCode === 'Participant'){
              this.userRoleId = x.id;
            }
          });
        }
      });
      await RelationshipService.showLinkedMembers(this.userRoleId).then(response => {
        if(response.data.success == 1){
          riders = response.data.message;
        }

      });
      riders.forEach(element => {
        element.isEdit = true;
        this.ridersItems.push(element);
      });
      this.loadingData = false;
    },
    showSnackBar(msg, color){
      this.snackbar = true;
      this.msg_snackbar = msg;
      this.color_snackbar = color;
      setTimeout(() => this.snackbar = false, 3000);
    },
    editItem(item) {
      this.editedIndex = this.ridersItems.indexOf(item);
      this.form = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.ridersItems.indexOf(item);
      this.form = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.ridersItems.splice(this.editedIndex, 1);
      this.closeDelete();
      
      RelationshipService.relationshipDelete(this.form.linkedMemberId).then(response => {

        if(response.data.success == 1){
          this.ridersItems = [];
          this.showSnackBar(this.$t("riders.msg_success_deleted"), "success");
          this.showLinkedMembers();
        }

      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.form = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.form = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    editRider() {

      let data = {};

      data.relId = this.form.linkedMemberId;
      data.relType = this.form.relationship;
      data.userRoleId = this.userRoleId;
      RelationshipService.relationshipUpdate(data).then(response => {
        if(response.data.success == 1){
          this.dialog = false;
          this.ridersItems = [];
          this.showSnackBar(this.$t("riders.msg_success_edited"), "success");
          this.showLinkedMembers();
        }

      });
     
    }
  }
};
</script>

<style>
.riders .v-data-table-header,
.riders .v-card__title {
  background: #ccc;
}
.mt16 {
  margin-top: 16px;
}
.btn{
  color:#fff !important;
}
.v-card__actions{
  display: inherit;
  text-align: right;
}
</style>